import { memo } from 'react';
import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { Box } from '@mentimeter/ragnar-ui/box';
import { TitleSection } from '../../shared/components/title-section/TitleSection';
import { NonInteractiveVisualizationWrapper } from '../../shared/components/NonInteractiveVisualizationWrapper';
import type { ModeT } from '../../types';
import { Display } from './components/Display';
import { Public } from './components/Public';
import { Screenshot } from './components/Screenshot';

const Renderer = memo(({ mode }: { mode: ModeT }) => {
  if (mode === 'public') return <Public />;
  if (mode === 'screenshot') return <Screenshot />;
  return <Display />;
});

export function QfaPresentation() {
  const { useQuestion, useConfig, InteractiveCanvasComponents } =
    usePresentationContext();
  const {
    question,
    question_description,
    title_meta,
    layout,
    question_styled,
  } = useQuestion();
  const { mode } = useConfig();

  const ConditionalWrapper =
    InteractiveCanvasComponents?.CanvasVisualizationArea
      ? InteractiveCanvasComponents?.CanvasVisualizationArea
      : NonInteractiveVisualizationWrapper;

  return (
    <Box width="100%" height="100%" display="flex">
      <TitleSection
        title={question}
        styledTitle={question_styled}
        description={question_description}
        label={title_meta}
        fontSizeOffset={layout?.font_size_offset}
        mb="space4"
        showTextSizeDropdown={true}
      />
      <ConditionalWrapper
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
        flex="1 1 auto"
      >
        <Renderer mode={mode} />
      </ConditionalWrapper>
    </Box>
  );
}
